export default [
  {
    path: '/services',
    name: 'service',
    component: () => import('@/pages/Services/Selector.vue')
  },
  {
    path: '/services/campaign/:service/type/:type',
    name: 'service-campaign-launch',
    component: () => import('@/pages/Services/Selector/CampaignLauncher.vue')
  },
  {
    path: '/services/campaign/:service/configuration',
    name: 'service-campaign-configuration',
    component: () => import('@/pages/Services/Selector/CampaignLauncher.vue')
  },
  {
    path: '/services/senders',
    name: 'service-senders',
    component: () => import('@/pages/Services/Senders.vue')
  },
  {
    path: '/management/supervisor',
    name: 'supervisor-dashboard',
    component: () => import('@/pages/Chat/supervisor/CampaignWhatsappCharts.vue')
  },

  // WORKGROUPS
  {
    path: '/management/workgroups',
    name: 'workgroups',
    component: () => import('@/pages/Workgroups/Dashboard.vue')
  },

  {
    path: '/management/workgroups/:workgroup_id/settings',
    name: 'workgroups-settings',
    component: () => import('@/pages/Workgroups/components/WorkgroupSettings.vue')
  },
  {
    path: '/management/strategies',
    name: 'strategy-settings',
    component: () => import('@/pages/Workgroups/components/StrategySettings.vue')
  },
  {
    path: '/management/bots/:bot_name/flow_interactions',
    name: 'flow-interactions',
    component: () => import('@/pages/bots/BotFlowInteractions.vue')
  },

  // TEMPORAL
  {
    path: '/management/mm_lite_onboarding',
    name: 'mm_lite_onboarding',
    component: () => import('@/pages/mmLiteOnboarding.vue')
  },
  //REPORTS
  {
    path: '/reports/campaigns',
    name: 'reports',
    component: () => import('@/pages/Reports/Reports.vue')

  },
  {
    path: '/reports/registers',
    name: 'registers',
    component: () => import('@/pages/Reports/Registers.vue')
  },
  {
    path: '/reports/sms/detail/:campaign_id',
    name: 'reports-sms',
    component: () => import('@/pages/Reports/DetailSmsReport.vue')
  },
  {
    path: '/reports/email/detail/:campaign_id',
    name: 'reports-email',
    component: () => import('@/pages/Reports/DetailEmailReport.vue')
  },
  {
    path: '/reports/whatsapp/detail/:campaign_id',
    name: 'reports-whatsapp',
    component: () => import('@/pages/Reports/DetailWhatsappReport.vue')
  },
  {
    path: '/enviamas-documentation',
    name: 'enviamas-documentation',
    component: () => import('@/pages/Documentacion/RedirectToDocumentation.vue')
  },
  {
    path: '/tools/blacklist',
    name: 'black-list',
    component: () => import('@/pages/Blacklist/Blacklist.vue')
  },
  {
    path: '/tools/blacklist/:blacklist_id',
    name: 'black-list-element',
    component: () => import('@/pages/Blacklist/BlacklistMessages.vue')
  },
]
